<template>
  <section id="ecosystem" class="projects-section" aria-labelledby="projects-title">
    <div class="projects-section__watermark" aria-hidden="true">
      <span style="color: var(--surface-color);">x89</span>Eco
    </div>

    <div class="projects-section__inner">

      <div
        class="projects-slider"
        aria-live="polite"
        @mouseenter="pauseAutoSlide"
        @mouseleave="resumeAutoSlide"
      >
        <div class="projects-slider__viewport">
          <div
            class="projects-slider__track"
            :style="{ transform: `translateX(-${activeIndex * 100}%)` }"
          >
            <article
              v-for="(partner, index) in partners"
              :key="partner.name"
              class="project-slide"
              :class="{ 'is-active': index === activeIndex }"
            >
              <div class="project-slide__content">
                <h3>{{ partner.name }}</h3>
                <p class="project-slide__subtitle">{{ partner.subtitle }}</p>

                <ul class="project-slide__tags" aria-label="Project tags">
                  <li
                    v-for="tag in partner.tags"
                    :key="tag"
                    :class="{ 'project-slide__tag--highlight': tag === 'sponsor' || tag === 'partner' }"
                  >
                    {{ tag.replace(/_/g, ' ') }}
                  </li>
                </ul>
              </div>

              <div class="project-slide__visual">
                <img
                  class="project-slide__image"
                  :src="getImageUrl(partner.cover)"
                  :alt="`${partner.name} cover`"
                />
              </div>
            </article>
          </div>
        </div>

        <div class="projects-slider__controls">
          <button
            type="button"
            class="projects-slider__nav"
            aria-label="Previous project"
            @click="previousSlide"
          >
            ←
          </button>

          <div class="projects-slider__dots" aria-label="Select a project">
            <button
              v-for="(partner, index) in partners"
              :key="partner.name + '-dot'"
              type="button"
              class="projects-slider__dot"
              :class="{ 'is-active': index === activeIndex }"
              :aria-label="`Show project ${index + 1}`"
              @click="goToSlide(index)"
            />
          </div>

          <button
            type="button"
            class="projects-slider__nav"
            aria-label="Next project"
            @click="nextSlide"
          >
            →
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import partnersData from '@/data/ecosystem.json';

export default {
  name: 'EcosystemSection',
  data() {
    return {
      activeIndex: 0,
      partners: partnersData.partners,
      autoSlideTimer: null,
    };
  },
  mounted() {
    this.resumeAutoSlide();
  },
  beforeUnmount() {
    this.pauseAutoSlide();
  },
  methods: {
    nextSlide() {
      this.activeIndex = (this.activeIndex + 1) % this.partners.length;
    },
    previousSlide() {
      this.activeIndex = (this.activeIndex - 1 + this.partners.length) % this.partners.length;
    },
    goToSlide(index) {
      this.activeIndex = index;
    },
    getImageUrl(filename) {
      return require(`@/assets/images/ecosystem/${filename}`);
    },
    resumeAutoSlide() {
      if (this.autoSlideTimer || this.partners.length < 2) return;

      this.autoSlideTimer = window.setInterval(() => {
        this.nextSlide();
      }, 6000);
    },
    pauseAutoSlide() {
      if (!this.autoSlideTimer) return;

      window.clearInterval(this.autoSlideTimer);
      this.autoSlideTimer = null;
    },
  },
};
</script>
